import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {AuthService} from '../../core/auth/auth.service';

@Component({
  selector: 'app-change-card',
  templateUrl: './change-card.component.html',
  styleUrls: ['./change-card.component.scss']
})
export class ChangeCardComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('cardInfo') cardInfo: ElementRef;

  @Output() changeCard = new EventEmitter<any>();

  card: any;

  error: string;

  valError: string;

  success: string;

  processing: boolean;

  cardHandler = this.onChange.bind(this);

  constructor(private authService: AuthService, private cd: ChangeDetectorRef) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.card = elements.create('card');
    this.card.mount(this.cardInfo.nativeElement);

    this.card.addEventListener('change', this.cardHandler);
  }

  onChange({ error }) {
    if (error) {
      this.valError = error.message;
    } else {
      this.valError = null;
    }
    this.cd.detectChanges();
  }

  update() {
    this.processing = true;
    stripe.createToken(this.card)
      .then((res) => {
        this.error = '';
        this.authService.changeCard({token: res.token, customerId: this.authService.getProfile().stripeCustomerId})
          .subscribe((res: any) => {
            this.processing = false;
            this.success = 'You have changed a credit card';
            this.authService.updateProfile({cardNumber: res.cardNumber, cardToken: res.cardToken})
            setTimeout(() => {
              this.changeCard.next();
            }, 2000);
          }, (err) => {
            this.processing = false;
            this.error = err.error.message || 'An error occurred';
          });
      })
      .catch((err) => {
        this.processing = false;
        this.error = err.error.message || 'An error occurred';
      });
  }

  ngOnDestroy() {
    this.card.removeEventListener('change', this.cardHandler);
    this.card.destroy();
  }

}



// WEBPACK FOOTER //
// ./client/app/components/change-card/change-card.component.ts